<template lang="pug">
.task-container
  .task-list-block(v-for="(item,index) in localTaskList" )
    .task-left
      .task-line
      .task-img
        img.task-img--content(:src="item.taskImgUrl")
    .task-right
      .task-line(:style="{ borderTop: index === 0 ? 'none' : '0.005rem solid #e1e6eb' }")
      .task-right-bottom
        .task-middle-block
          .task-middle-block-line
            .task-middle-block-line-word {{item.guideDesc}}{{item.guideAwardDesc}}
            .task-middle-block-line-two {{item.currentProgress}}/{{item.totalProgress}}次
          .task-middle-block-line-one(
            ref="textContent"
            :class="{'expanded': item.isExpanded,'showArrow': shouldShowArrow(index)}"
            @click="toggleExpand(index)"

          ) {{item.additionalDesc}}
          .task-middle-block-change 每单可返奖励金
            .task-middle-block-line-award
              img.title-img(src="https://m.hellobike.com/resource/helloyun/08345/qSbGFKFPtD.png")
              span +{{item.offerWorth}}
        .task-right-btn(v-if="btnType(item)" @click="doTask(item)")
          span {{item.btnName}}
        .task-right-gary(v-else) {{item.btnName}}
</template>
<script>
import { env, Native } from '@hb/hbridge';

export default {
  props: {
    taskList: {
      type: Array,
      default() {
        return [];
      },
    },
    showAward: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localTaskList: [],
      textOverflowMap: [],
    };
  },

  watch: {
    taskList: {
      immediate: true,
      handler(newVal) {
        // 当taskList变化时，更新localTaskList
        this.localTaskList = newVal.map((task) => ({
          ...task,
          isExpanded: false,
        }));
        this.checkTextOverflow();
      },
    },
  },

  methods: {
    doTask(item) {
      let channel = 'app';
      if (env.isAliMP || env.isAliMPMonitor) {
        channel = 'ali';
      }
      const link = item.btnLink[channel];
      if (channel === 'ali') {
        Native.callNative({
          method: 'goOperationUrlV2',
          params: link,
        });
      } else {
        window.location.href = link;
      }
    },
    btnType(item) {
      if (item.currentProgress >= 0 && (item.currentProgress === item.totalProgress)) {
        return false;
      }
      return true;
    },
    toggleExpand(index) {
      this.$set(this.localTaskList[index], 'isExpanded', !this.localTaskList[index].isExpanded);
    },
    // 判断是否应该显示箭头
    shouldShowArrow(index) {
      return this.textOverflowMap[index] && !this.localTaskList[index].isExpanded;
    },
    // 检查文本是否溢出
    checkTextOverflow() {
      this.$nextTick(() => {
        this.textOverflowMap = this.localTaskList.map((task, index) => {
          const textContent = this.$refs.textContent[index];
          if (textContent) {
            return textContent.scrollWidth > textContent.clientWidth;
          }
          return false;
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.task-container {
  border-radius: 0.2rem;
  background: #fff;

  .task-list-block {
    overflow-y: auto;
    display: flex;
    padding: 0 0.16rem 0.16rem 0.16rem;

    .task-left {
      flex-shrink: 0;

      .task-line {
        height: 0.17rem;
        width: 0.4rem;
      }

      .task-img {
        .task-img--content {
          width: 0.44rem;
          height: 0.44rem;
        }
      }
    }

    .task-right {
      min-width: 0;  // 防止 flex 子元素溢出
      overflow: hidden;  // 确保内容不会溢出
      flex: 1;

      .task-line {
        width: 100%;
        height: 0.17rem;
      }

      .task-right-bottom {
        display: flex;
        justify-content: space-between;

        .task-middle-block {
          margin-left: 0.08rem;
          display: flex;
          flex-direction: column;
          flex: 1;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          min-width: 0; // 防止flex子元素溢出

          .task-middle-block-line-one {
            font-size: 0.12rem;
            color: #879099;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            position: relative;
            // one line

            &::after {
              display: none; // 默认隐藏箭头
            }

            &.showArrow {
              cursor: pointer;
              padding-right: 0.24rem;

              &::after {
                display: block; // 显示箭头
              }
            }

            &:not(.expanded)::after {
              content: '';
              position: absolute;
              right: 0.18rem;
              top: 40%;
              width: 0.07rem; // 减小箭头尺寸
              height: 0.07rem; // 减小箭头尺寸
              border-top: 0.01rem solid #879099;
              border-right: 0.01rem solid #879099;
              // 旋转箭头 向下
              transform: translateY(-50%) rotate(135deg);
            }

            &.expanded {
              white-space: normal;
              text-overflow: initial;
              overflow: visible;
            }
          }

          .task-middle-block-line {
            display: flex;
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            font-size: 0.14rem;
            font-weight: 500;
            color: #242729;

            .task-middle-block-line-two {
              margin-left: 0.04rem;
            }
          }

          .task-middle-block-change {
            margin-top: 0.04rem;
            display: flex;
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            font-size: 0.12rem;
            font-weight: 400;
            line-height: 0.168rem;
            color: #242729;

            .task-middle-block-line-award {
              margin-top: 0.03rem;
              height: 0.14rem;
              background: #ffefd6;
              border-radius: 0.5rem;
              margin-left: 0.08rem;
              color: #fa4614;
              font-weight: 500;
              font-size: 0.12rem;
              line-height: 0.14rem;
              display: flex;
              padding-right: 0.03rem;

              .title-img {
                width: 0.14rem;
                height: 0.14rem;
                border-radius: 50%;
              }
            }
          }
        }

        .task-right-gary {
          margin-top: 0.08rem;
          width: 0.72rem;
          height: 0.26rem;
          border-radius: 0.5rem;
          color: #bcc4cc;
          text-align: center;
          line-height: 0.26rem;
          background: #f0f3f5;
          font-size: 0.12rem;
        }

        .task-right-btn {
          margin-top: 0.08rem;
          width: 0.72rem;
          height: 0.26rem;
          border-radius: 0.5rem;
          color: #fa4614;
          text-align: center;
          line-height: 0.26rem;
          background: #fff1db;
          font-size: 0.12rem;
        }

        .task-right-get-btn {
          display: flex;
          justify-content: center;
          margin-top: 0.08rem;
          width: 0.63rem;
          height: 0.26rem;
          background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
          color: #fff;
          font-size: 0.12rem;
          line-height: 0.26rem;
          border-radius: 0.5rem;

          img {
            margin-top: 0.06rem;
            margin-left: 0.03rem;
            width: 0.14rem;
            height: 0.14rem;
          }
        }
      }
    }
  }
}
</style>
